import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { cn } from 'src/components/ui/lib/utils';
import { useAuth } from 'src/libs/rainbow';
import './styles.scss';
type Slice = {
  name: string;
  value: number;
  color: string;
};

type Props = {
  data: Slice[];
  size?: number;
  score?: number;
};

const scoreToTextSize = (score: number) => {
  if (score < 1000) {
    return 'text-3xl';
  }
  if (score < 10000) {
    return 'text-2xl';
  }
  if (score < 100000) {
    return 'text-xl';
  }
  if (score < 1000000) {
    return 'text-base';
  }
  if (score < 10000000) {
    return 'text-sm';
  }
  if (score < 100000000) {
    return 'text-xs';
  }
  return 'text-[10px]';
};
const NeonPieChart: React.FC<Props> = ({ data, size = 300, score }) => {
  const { isAuthenticated } = useAuth();

  return (
    <div
      style={{
        width: size,
        height: size,
        position: 'relative',
      }}
      className="flex items-center justify-center"
    >
      <ResponsiveContainer className={'no-focus z-[3] absolute'} width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            outerRadius="80%"
            innerRadius={'50%'}
            paddingAngle={0}
            stroke={'rgba(50, 50, 50, 0.29)'}
            minAngle={5}
          >
            {data.map((entry, index) => (
              <Cell
                key={`slice-${index}`}
                fill={entry.color}
                style={{
                  filter: `drop-shadow(0 0 8px ${entry.color}) drop-shadow(0 0 8px ${entry.color})`,
                }}
              />
            ))}
          </Pie>

          <Tooltip
            contentStyle={{
              backgroundColor: 'rgba(0,0,0,0.8)',
              border: '1px solid #0ff',
              borderRadius: '8px',
              color: '#0ff',
              fontSize: '12px',
              textShadow: '0 0 4px #0ff',
            }}
            wrapperStyle={{ zIndex: 9999 }}
            itemStyle={{
              color: '#fff',
              textShadow: '0 0 4px #fff',
            }}
          />
        </PieChart>
      </ResponsiveContainer>
      <div className="z-[2]">
        <div className="relative">
          <div className="absolute inset-0 rounded-full bg-black opacity-20 scale-110"></div>
          <div className="relative w-32 h-32 rounded-full border-4 border-cyan-400/30 flex items-center justify-center">
            <div className="absolute inset-2 rounded-full bg-black"></div>
            <div className="relative text-center">
              <div
                className={cn([
                  'text-base font-bold text-[#616f70] text-white dark:text-cyan-100 tracking-wider',
                  scoreToTextSize(score ?? 0),
                ])}
              >
                {isAuthenticated ? score ?? 0 : 0}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NeonPieChart;
